import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css, useTheme } from '@emotion/react';
const highlightText = css `
	background-color: #ffe500;
	padding: 0 5px;
`;
const observerHighlightColor = css `
	background-color: #f1c7aa;
`;
export default function HighlightText({ children }) {
    const { observerThemeButton } = useTheme();
    return (_jsx("span", { css: [highlightText, observerThemeButton && observerHighlightColor], children: children }));
}
